import axios from 'axios'

export interface CpvCode {
  code: string;
  name: string;
}

export interface CpvCodeTreeNode {
  id: string;
  label: string;
  children: CpvCodeTreeNode[];
}

export async function getCpvCodes(lang: string, hilmaApiEndpoint: string) {
  const headers = {
    headers: {
      'cache-control': 'public',
    },
  }
  const returned = await axios.get(`${hilmaApiEndpoint}cpv/?contractType=0&lang=${lang}`, headers)
  return returned.data as CpvCode[]
}

export async function getCpvTree(lang: string, hilmaApiEndpoint: string) {
  const headers = {
    headers: {
      'cache-control': 'public',
    },
  }
  const returned = await axios.get(`${hilmaApiEndpoint}cpv/tree?contractType=0&lang=${lang}`, headers)
  return returned.data as CpvCode[]
}
